module.exports = __webpack_public_path__ + "img/AsiaGInsta_Final.3e22364c.jpg";